import toPairs from "lodash/toPairs";
import fromPairs from "lodash/fromPairs";
import isUndefined from "lodash/isUndefined";

export const cleanProps = props => {
  return fromPairs(toPairs(props).filter(([, value]) => !isUndefined(value)));
};
